import React from "react";
import { Box, Typography } from "@mui/material";
import Colors from "../assets/color";
import reserve_booking from "../assets/images/reserve_booking.gif";

const EndlessPossibilities = () => {

  return (
    <Box
      sx={{
        overflow: "hidden",
        backgroundColor: '#0e0e0e',
        p: { xs: '64px 20px', sm: '64px 40px', md: '112px 64px' },
      }}
    >
      <Typography
        component='h1'
        sx={{
          color: 'white',
          fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.8rem' },
          textAlign: 'center',
          fontWeight: '700',
          m: '0rem auto 4rem',
          lineHeight: { xs: '4.4rem', sm: '5rem', md: '5.6rem' },
        }}>
        One Platform. Every Charger. Endless Possibilities.
      </Typography>

      <Box sx={{
        display: "flex",
        flexDirection: { xs: 'column', sm: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000000',
        width: 'fit-content',
        margin: '0 auto',
        borderRadius: '25px',
        p: { xs: '3rem 7rem' },
        gap: '6rem',
      }}>

        <Box
          sx={{
            width: { xs: "100%", md: '500px', },
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            height: '640px'
          }}
        >
          <img src={reserve_booking} alt="Description of GIF" style={{ width: '140%', maxWidth: '32rem' }} />
        </Box>


        <Box sx={{}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontSize: '2.4rem',
                fontWeight: 700,
                maxWidth: '35ch',
                textAlign: { xs: 'left' },
                lineHeight: '3rem',
              }}
            >
              Sick of unreliable chargers? <br /> Discover safe, nearby stations that actually work.
            </Typography>

            <Typography
              sx={{
                fontSize: "1.6rem",
                fontWeight: "400",
                maxWidth: "55ch",
                textAlign: "left",
                color: '#FEFFFACC'
              }}
            >
              Save up to $600 annually compared to public charging rates
              Access thousands of private chargers with no long waits or overpricing during peak hours
              Enjoy predictable pricing with flexible subscription plans
            </Typography>

            <Typography
              sx={{
                color: "primary.main",
                fontSize: '2.4rem',
                fontWeight: 700,
                maxWidth: '35ch',
                textAlign: { xs: 'left' },
                lineHeight: '3rem',
              }}
            >
              Own a private charger? <br /> Turn it into passive income.
            </Typography>

            <Box
              component="ul"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                width: "100%",
                p: "0 2rem",
                listStyleType: "disc",
                " > *": {
                  fontSize: "1.6rem",
                  fontWeight: "400",
                  maxWidth: "55ch",
                  textAlign: "left",
                  color: '#FEFFFACC'
                },
              }}
            >
              <Box component="li">
                Earn $700+ per month by hosting your EV charger on the SplitEV network
              </Box>

              <Box component="li">
                High-demand areas can earn over $1,800/month.
              </Box>

              <Box component="li">
                Payments are automatically deposited into your account monthly
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EndlessPossibilities;
